import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '../redux/userSlice';
import { useHistory, Link } from 'react-router-dom';
import loginimage from "../images/loginimage.jpeg";

const Login = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const [errors, setErrors] = useState([]);

    const [formData, setFormData] = useState({
        username: "",
        password: "",
      });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        fetch("https://fotoset.herokuapp.com/login", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((r) => {
            return r.json().then((data) => {
              console.log(data)
              if (r.ok) {
                return data;
              } else {
                throw data;
              }
            });
          })
          .then((data) => {
            const { user, token } = data;
            localStorage.setItem("token", token);
            dispatch(updateUser(user))
            history.push("/");
            setTimeout(function(){
              window.location.reload()
            }, 0)
          })
          .catch((error) => {
            if (error) {
            setErrors(error.errors);
            }
          });
      }

    return(
<div className="login-page">
    <div className="login-form">
        <div className="login-left">
              <img src={loginimage} alt="login img" />
        </div>
        <div className="form-box-right">
          <form onSubmit={handleSubmit}>
            <h1 className="login-text">Sign In</h1>
            <label id="label">Username</label><br></br>
            <input
              type="text"
              name="username"
              className="login-box"
              placeholder="Username"
              value={formData.username}
              onChange={handleChange}
            /><br></br>
            <label id="label">Password</label><br></br>
            <input
              type="password"
              name="password"
              className="login-box"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
            /><br></br>

            {errors.map(error => 
            <p style={{ color: "red"}} key={error}>
              {error}
            </p>
            )}
            <input type="submit" value="Sign In" className="login-btn" />
            <div id="signup-btn">
            <p className="text-center">Not a member?</p>
            <Link to="/signup"><button className="signup-btn">Sign Up</button></Link>
            </div>
          </form>
        </div>
    </div>
  </div>
    )
}

export default Login;